import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initI18n } from './i18n';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Φόρτωσε τις μεταφράσεις παράλληλα στο background.
// Το i18next/react-i18next θα ενημερώσει αυτόματα τα components
// που χρησιμοποιούν useTranslation() μόλις έρθουν τα δεδομένα.
initI18n();